import {useEffect, useState} from 'react'
import {initialQueryState, KTSVG} from '../../../../../../../../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import moment from 'moment'
import {MenuComponent} from '../../../../../../../../../../../_metronic/assets/ts/components'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {Calendar} from 'primereact/calendar'

const ContractPaymentFilter = () => {
  const intl = useIntl()
  const {updateState} = useQueryRequest()

  //variaval de controle do filtro avançado
  const [openFilterWin, setOpenFilterWin] = useState<boolean>(false)

  //variaveis de controle de intervalo de datas
  const [openDatePayday, setOpenDatePayday] = useState<boolean>(false)
  const [openDateReference, setOpenDateReference] = useState<boolean>(false)

  //variaveis normais
  const [observations, setobservations] = useState<string | undefined>()
  const [status, setstatus] = useState<string | undefined>()

  //variaveis de Datas e intervalos de datas
  const [reference_date, setreference_date] = useState<Date | undefined>()
  const [reference_dateD, setreference_dateD] = useState<Date | undefined>()
  const [reference_date_between, setreference_date_between] = useState<Date | undefined>()
  const [reference_date_betweenD, setreference_date_betweenD] = useState<Date | undefined>()

  const [payday, setpayday] = useState<Date | undefined>()
  const [paydayD, setpaydayD] = useState<Date | undefined>()

  const [payday_between, setpayday_between] = useState<Date | undefined>()
  const [payday_betweenD, setpayday_betweenD] = useState<Date | undefined>()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  // função que reseta os filtros
  const resetData = () => {
    updateState({filter: undefined, ...initialQueryState})

    setobservations(undefined)
    setreference_date(undefined)
    setreference_date_between(undefined)
    setreference_date_betweenD(undefined)
    setpayday(undefined)
    setpayday_between(undefined)
    setpayday_betweenD(undefined)
    setobservations('')
    setstatus('')
  }

  // função que faz a busca dos dados
  const filterData = () => {
    updateState({
      filter: {
        status,
        observations,
        reference_date,
        reference_date_between,
        payday,
        payday_between,
      },
      ...initialQueryState,
    })
  }

  // função que abre o filtro avançado
  const openFilter = () => {
    if (openFilterWin === false) {
      setOpenFilterWin(true)
    } else {
      setOpenFilterWin(false)
    }
  }

  // função que abre o filtro de data conclusão por intervalo
  const openDConclusion = () => {
    if (openDatePayday === false) {
      setOpenDatePayday(true)
    } else {
      setOpenDatePayday(false)
    }
  }

  // função que abre o filtro de data de inicio por intervalo
  const openDStart = () => {
    if (openDateReference === false) {
      setOpenDateReference(true)
    } else {
      setOpenDateReference(false)
    }
  }

  const setConvertDate = (e: any, type: string, period: 'reference' | 'payment') => {
    switch (period) {
      case 'reference': {
        if (type === 'single') {
          let DateFormate: any
          DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
          console.log(DateFormate)
          setreference_date(DateFormate)
          setreference_dateD(e)
        } else if (type === 'range') {
          let DateFormate: any = []
          if (e.length === 2) {
            DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
            DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
          }

          setreference_date_between(DateFormate)
          setreference_date_betweenD(e)
        }
        break
      }
      case 'payment': {
        if (type === 'single') {
          let DateFormate: any
          DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
          console.log(DateFormate)
          setpaydayD(e)
          setpayday(DateFormate)
        } else if (type === 'range') {
          let DateFormate: any = []
          if (e.length === 2) {
            DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
            DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
          }
          setpayday_between(DateFormate)
          setpayday_betweenD(e)
        }
        break
      }
    }
  }

  return (
    <>
      <div className='card-body pt-0 '>
        {/* INICIO LINHA 1  FIXA DO FILTRO */}
        <div className='row'>
          {openDateReference === false && (
            <div className='col-lg-4'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.REFERENCE_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Calendar
                  data-kt-user-table-filter='start_date'
                  value={reference_dateD}
                  onChange={(e) => setConvertDate(e.value, 'single', 'reference')}
                  selectionMode='single'
                  inputClassName='form-control form-control-solid fs-6 ps-6 border border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aa'
                  showButtonBar
                />
                <button
                  type='button'
                  className='btn btn-sm btn-icon btn-primary m-1'
                  onClick={openDStart}
                  title='selecionar intervalo'
                >
                  <KTSVG
                    path='/media/icons/duotune//general/gen019.svg'
                    className='svg-icon-2 svg-icon-light'
                  />
                </button>
              </div>
            </div>
          )}
          {/* data intervalo */}
          {openDateReference === true && (
            <div className='col-lg-4'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.REFERENCE_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Calendar
                  data-kt-user-table-filter='start_date_betweenD'
                  value={reference_date_betweenD}
                  onChange={(e) => setConvertDate(e.value, 'range', 'reference')}
                  selectionMode='range'
                  inputClassName='form-control form-control-solid fs-6 ps-6 border border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aaaa - dd/mm/aaaa'
                  showButtonBar
                />
                <button
                  type='button'
                  className='btn btn-sm btn-icon btn-primary m-1'
                  onClick={openDStart}
                  title={intl.formatMessage({id: 'COMMON_REFERENCE_DATE'})}
                >
                  <KTSVG
                    path='/media/icons/duotune//general/gen019.svg'
                    className='svg-icon-2 svg-icon-light'
                  />
                </button>
              </div>
            </div>
          )}

          {/* inicio filtro de data de conclusão */}
          {openDatePayday === false && (
            <div className='col-lg-4'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.PAYMENT_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Calendar
                  data-kt-user-table-filter='start_date'
                  value={paydayD}
                  onChange={(e) => setConvertDate(e.value, 'single', 'payment')}
                  selectionMode='single'
                  inputClassName='form-control form-control-solid fs-6 ps-6 border border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aa'
                  showButtonBar
                />
                <button
                  type='button'
                  className='btn btn-sm btn-icon btn-primary m-1'
                  onClick={openDConclusion}
                  title={intl.formatMessage({id: 'CONTRACTS.PAYMENT_DATE'})}
                >
                  <KTSVG
                    path='/media/icons/duotune//general/gen019.svg'
                    className='svg-icon-2 svg-icon-light'
                  />
                </button>
              </div>
            </div>
          )}
          {/* data intervalo */}
          {openDatePayday === true && (
            <div className='col-lg-4'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.PAYMENT_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Calendar
                  data-kt-user-table-filter='start_date_betweenD'
                  value={payday_betweenD}
                  onChange={(e) => setConvertDate(e.value, 'range', 'payment')}
                  selectionMode='range'
                  inputClassName='form-control form-control-solid fs-6 ps-6 border border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aaaa - dd/mm/aaaa'
                  showButtonBar
                />
                <button
                  type='button'
                  className='btn btn-sm btn-icon btn-primary m-1'
                  onClick={openDConclusion}
                  title={intl.formatMessage({id: 'CONTRACTS.PAYMENT_DATE'})}
                >
                  <KTSVG
                    path='/media/icons/duotune//general/gen019.svg'
                    className='svg-icon-2 svg-icon-light'
                  />
                </button>
              </div>
            </div>
          )}

          {/* filtro de status  */}
          <div className='col-lg-4 mt-0'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'COMMON.STATUS'})}
            </label>
            <div className='d-flex align-items-center position-relative my-1'>
              <select
                className='form-select form-select-solid ps-6'
                data-kt-select2='true'
                data-kt-user-table-filter='paid'
                onChange={(e) => setstatus(e.target.value)}
                value={status}
              >
                <option value='all'>{intl.formatMessage({id: 'COMMON.ALL'})}</option>
                <option value='true'>{intl.formatMessage({id: 'CONTRACTS.PAID'})}</option>
                <option value='false'>{intl.formatMessage({id: 'CONTRACTS.NO_PAID'})}</option>
              </select>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-primary btn-active-primary p-3 ms-3  '
                onClick={openFilter}
                title='Mais Filtros'
              >
                <i className='bi bi-sliders2-vertical fs-2' />
              </button>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-danger p-3 m-1'
                onClick={resetData}
                title='Limpar'
              >
                <KTSVG path='/media/icons/duotune/art/art004.svg' className='svg-icon-3' />
              </button>
              <button
                type='button'
                className='btn btn-sm btn-primary m-1'
                onClick={filterData}
                title='Filtar'
              >
                {intl.formatMessage({id: 'COMMON.SEARCH'})}
              </button>
            </div>
          </div>
        </div>

        {/* INICIO LINHA 3 */}
        {/* filtro de TAGS */}
        {openFilterWin && (
          <div className='row mt-2'>
            {/* filtro de descrição */}
            <div className='col-lg-12'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='text'
                  data-kt-user-table-filter='observations'
                  className='form-control form-control-solid ps-6'
                  placeholder={
                    intl.formatMessage({id: 'COMMON.SEARCH'}) +
                    ' ' +
                    intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})
                  }
                  onChange={(e: any) => setobservations(e.target.value)}
                  value={observations}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export {ContractPaymentFilter}
